function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDuszek = function SvgDuszek(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 288.468,
    height: 326.229,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 7113 8045"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1802 4628h3498m1812 2782V3555C7112 1599 5512-1 3556-1S0 1599 0 3555v3888c0 332 269 600 600 600 296 0 541-214 591-495 50 281 296 495 591 495 296 0 541-214 591-495 50 281 296 495 591 495 296 0 541-214 591-495 50 281 296 495 591 495 296 0 541-214 591-495 50 281 296 495 591 495 296 0 541-214 591-495 50 281 296 495 591 495 332 0 600-269 600-600 0-11 0-22-1-33zM4704 4743v785c0 64-52 115-115 115-64 0-115-52-115-115v-785h-477v577c0 164 67 313 175 421s256 174 419 174 312-67 419-174c108-108 175-257 175-421v-577h-480zm-2902 0c-64 0-115-52-115-115 0-64 52-115 115-115h3498c64 0 115 52 115 115v692c0 226-93 431-242 581-149 149-355 242-582 242s-433-93-582-242-242-355-242-581v-577H1802zm3356-2335c45-45 45-118 0-163s-118-45-163 0l-283 283-283-283c-45-45-118-45-163 0s-45 118 0 163l283 283-283 283c-45 45-45 118 0 163s118 45 163 0l283-283 283 283c45 45 118 45 163 0s45-118 0-163l-283-283 283-283zm-2540 0c45-45 45-118 0-163s-118-45-163 0l-283 283-283-283c-45-45-118-45-163 0s-45 118 0 163l283 283-283 283c-45 45-45 118 0 163s118 45 163 0l283-283 283 283c45 45 118 45 163 0s45-118 0-163l-283-283 283-283z",
    style: {
      fill: "#333"
    }
  }));
};
export default SvgDuszek;